import { render, staticRenderFns } from "./department-list.vue?vue&type=template&id=a327286e&scoped=true"
import script from "./department-list.vue?vue&type=script&lang=js"
export * from "./department-list.vue?vue&type=script&lang=js"
import style0 from "./department-list.vue?vue&type=style&index=0&id=a327286e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a327286e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a327286e')) {
      api.createRecord('a327286e', component.options)
    } else {
      api.reload('a327286e', component.options)
    }
    module.hot.accept("./department-list.vue?vue&type=template&id=a327286e&scoped=true", function () {
      api.rerender('a327286e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/department-management/department-list.vue"
export default component.exports